import React from 'react';
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Container from 'common/Container';
import { useTheme } from '@material-ui/core/styles';
import { readableHeading } from '../readablePalette';

const LEGALMENTE_LOGO = '/images/logos/LOGO%20legalmente.png';

const Hero = ({ themeMode = 'light' }) => {
  const theme = useTheme();
  const h = readableHeading(theme);

  return (
    <Box>
      <Box marginBottom={3}>
        <Container
          sx={{
            backgroundImage:
              themeMode === 'dark'
                ? 'url(/images/logos/logo_white.PNG)'
                : 'url(/images/logos/logo_tnonetwork_black.png)',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
            backgroundSize: 'contain',
            height: '16vh',
          }}
        />
        <Typography
          sx={{ textTransform: 'uppercase', fontWeight: 600, letterSpacing: '0.12em' }}
          variant="overline"
          color="textSecondary"
          align="center"
          display="block"
          gutterBottom
        >
          Propuesta de alianza estratégica
        </Typography>
        <Box
          component={Typography}
          fontWeight={700}
          variant="h3"
          gutterBottom
          align="center"
          sx={{ fontFamily: 'Georgia, "Times New Roman", serif', color: h }}
        >
          Hoet & Partners × Legalmente en Familia
        </Box>
        <Typography
          variant="h5"
          component="p"
          align="center"
          sx={{
            fontWeight: 600,
            color: theme.palette.secondary.main,
            fontStyle: 'italic',
            fontFamily: 'Georgia, "Times New Roman", serif',
            mb: 2,
          }}
        >
          Protegiendo el legado y la creatividad de la familia venezolana
        </Typography>
        <Box display="flex" justifyContent="center" mb={3}>
          <Box
            component="img"
            src={LEGALMENTE_LOGO}
            alt="Legalmente en Familia — programa ancla"
            sx={{ width: 140, maxWidth: '42%', height: 'auto', objectFit: 'contain' }}
          />
        </Box>
        <Typography variant="body1" color="textSecondary" align="center" sx={{ maxWidth: 800, mx: 'auto', lineHeight: 1.75 }}>
          Esta propuesta para la firma <strong>Hoet & Partners</strong> resalta su prestigio en propiedad intelectual dentro
          del programa <strong>Legalmente en Familia</strong>, aprovechando el perfil de la{' '}
          <strong>Dra. Leila Davogustto</strong> como autoridad y guardiana de derechos. Al ser una firma de alto nivel, el
          enfoque no es solo publicitario, sino de <strong>autoridad legal</strong> y <strong>protección patrimonial</strong>.
        </Typography>
      </Box>
    </Box>
  );
};

Hero.propTypes = {
  themeMode: PropTypes.string,
};

export default Hero;
